/**
 * Category A shared CSS constants for AdminTenantDetailPage + subcomponents.
 */
export const sectionCardClass =
  "mb-0 overflow-hidden rounded-[12px] border border-[#1c2035] bg-[#10121a]";

export const labelClass =
  "mb-1 block text-[9px] font-medium uppercase tracking-[0.5px] text-[#4a5070]";

export const textareaClass =
  "box-border min-h-[80px] w-full resize-y rounded-[7px] border border-[#1c2035] bg-[#141720] px-[12px] py-[10px] font-['DM_Sans'] text-[12px] text-[#edf0f7] outline-none placeholder:text-[#4a5070] focus:border-[#242840]";

export const sectionTitleClass =
  "text-[11px] font-medium uppercase tracking-[0.5px] text-[#edf0f7]";

export const gridTwoCol = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
  gap: "12px 20px",
};

export const tableClass =
  "w-full border-collapse text-[11px] text-[#8892b0]";

export const thCellClass =
  "border-b border-[#1c2035] px-[14px] py-2 text-left text-[9px] font-medium uppercase tracking-[0.6px] text-[#4a5070]";

export const tdCellClass =
  "border-b border-[#1c2035] px-[14px] py-[9px] align-middle text-[11px] text-[#8892b0]";

export const inputClass =
  "box-border w-full rounded-[7px] border border-[#1c2035] bg-[#141720] px-2.5 py-2 text-sm text-[#edf0f7] outline-none placeholder:text-[#4a5070] focus:border-[#242840]";

/** Dark pills for lifecycle preview in tenancy assign/edit UI (keys from deriveTenancyLifecyclePreviewForAssign). */
export const TENANCY_LIFECYCLE_PREVIEW_BADGE_CLASS = {
  active:
    "inline-flex items-center rounded-full border border-emerald-300 bg-emerald-100 px-2.5 py-0.5 text-[10px] font-semibold text-emerald-700 dark:bg-emerald-500/10 dark:border-emerald-500/20 dark:text-emerald-400",
  notice_given:
    "inline-flex items-center rounded-full border border-amber-500/20 bg-amber-500/10 px-2.5 py-0.5 text-[10px] font-bold text-amber-400",
  reserved:
    "inline-flex items-center rounded-full border border-amber-500/20 bg-amber-500/10 px-2.5 py-0.5 text-[10px] font-bold text-amber-400",
  ended:
    "inline-flex items-center rounded-full border border-red-500/20 bg-red-500/10 px-2.5 py-0.5 text-[10px] font-bold text-red-400",
};

/** Backend lifecycle_calendar_status (Sprint 2e); same pill geometry as TENANCY_LIFECYCLE_PREVIEW_BADGE_CLASS. */
export const TENANCY_LIFECYCLE_STATUS_BADGE_CLASS = {
  secure:
    "inline-flex items-center rounded-full border border-emerald-300 bg-emerald-100 px-2.5 py-0.5 text-[10px] font-semibold text-emerald-700 dark:bg-emerald-500/10 dark:border-emerald-500/20 dark:text-emerald-400",
  cancellable:
    "inline-flex items-center rounded-full border border-amber-500/20 bg-amber-500/10 px-2.5 py-0.5 text-[10px] font-bold text-amber-300",
  notice_given:
    "inline-flex items-center rounded-full border border-orange-500/25 bg-orange-500/10 px-2.5 py-0.5 text-[10px] font-bold text-orange-300",
  always_cancellable:
    "inline-flex items-center rounded-full border border-sky-500/25 bg-sky-500/10 px-2.5 py-0.5 text-[10px] font-bold text-sky-300",
  free_planned:
    "inline-flex items-center rounded-full border border-slate-500/25 bg-slate-500/10 px-2.5 py-0.5 text-[10px] font-bold text-slate-300",
  reserved:
    "inline-flex items-center rounded-full border border-violet-500/25 bg-violet-500/10 px-2.5 py-0.5 text-[10px] font-bold text-violet-300",
};
